// extracted by mini-css-extract-plugin
module.exports = {"badge":"BadgePicker_badge__k0Xwt"};